import React, {useEffect, useState} from 'react';
import {Checkbox, Divider, FormControlLabel, FormGroup, Grid, RadioGroup, TextField, Typography} from "@mui/material";
import * as Yup from 'yup';
import {useParams} from 'react-router-dom';
import useAuth from "../../../hooks/useAuth";
import GeneralEditor, {MODE_CREATE, MODE_EDIT} from "../../../components/CrudFrom/GeneralEditor";
import {executeMutationUtil, executeQueryUtil} from "../../../utils/gqlUtil";
import localStrings from "../../../localStrings";
import {useNavigate} from "react-router";
import {dashboardBaseRoute} from "../../../routes/dashboard";
import {not_found_path} from "../../../routes";
import {
    addDataChartImplementationToCache,
    createChartImplementationMutation,
    getChartImplementationQuery,
    updateChartImplementationMutation
} from "../../../gql/chartImplementationGql";
import AceCodeEditor from "../../../components/editor/AceCodeEditor";
import {getChartCategoriesQuery} from "../../../gql/chartCategoryGql";
import {Autocomplete} from "@mui/lab";

export const getChartImplementation = async (chartImplementationId,
                                             modeEdit, navigate) => {
    if (modeEdit == MODE_CREATE) {
        return null;
    }
    if (!modeEdit || modeEdit == MODE_EDIT) {
        var res =
            await executeQueryUtil(getChartImplementationQuery(chartImplementationId ));

        if (!res.data?.getChartImplementation) {
            navigate('/' + not_found_path);
            return;
        }
        return res;
    }
    return null;
}

export const saveForm = async (item, values, modeEdit, navigate, filter) => {
    let data;
    if (!modeEdit || modeEdit == MODE_EDIT) {
        data = {
            ...item,
            ...values,
            code: values.code || '',
            height: parseInt(values.height) || 350,
        };
        await executeMutationUtil(updateChartImplementationMutation(data));

    }

    else if (modeEdit == MODE_CREATE){
        data = {...values};
        const created = await executeMutationUtil(createChartImplementationMutation(data));
        await addDataChartImplementationToCache([created.data?.addChartImplementation]);
        if (navigate) {
            navigate("/" + dashboardBaseRoute + "/chartImplementations/detail/" + created.data?.addChartImplementation?.id);
        }
    }


    return data;
}

const codeStart = "async function getApexChartData(estaDetails, filter) {";
const ChartImplementationCreateUpdateForm = ({className, modeEdit}) => {

    const [chartCategories, setChartCategories] = useState(null);
    const [selectedChartCategory, setSelectedChartCategory] = useState(null);

    useEffect(() => {
        const loadData = async () => {
            let res = await executeQueryUtil(getChartCategoriesQuery());
            setChartCategories(res.data.getChartCategories);
        }
        loadData()
    }, []);

    let {chartImplementationId} = useParams();

    const {
        currentBrand,
        currentEstablishment,
        filter
    } = useAuth();
    const navigate = useNavigate();

    const buildFormValues = (item) => {
        return {
            initialValues: {
                name: item.name || '',
                code: item.code || '',
                chartMediaUrl: item.chartMediaUrl || '',
                allowedCategoryFilter: item.allowedCategoryFilter || false,
                allowedProductFilter: item.allowedProductFilter || false,
                allowedStaffFilter: item.allowedStaffFilter || false,
                allowedLocationFilter: item.allowedLocationFilter || false,
                allowedEstablishmentFilter: item.allowedEstablishmentFilter || false,


                allowedGroupByLocation: item.allowedGroupByLocation || false,
                allowedGroupByStaff: item.allowedGroupByStaff || false,
                allowedGroupByCategory: item.allowedGroupByCategory || false,
                allowedGroupByEstablishment: item.allowedGroupByEstablishment || false,

                chartCategoryId: item.chartCategoryId || null,

                title: item.title || null,
                height: item.height || 350,

            },
            validationSchema: {
                name: Yup.string().max(255).required(localStrings.check.fieldRequired),
                chartMediaUrl: Yup.string().url(localStrings.check.urlFormat).nullable(true),
                height: Yup.number().nullable(localStrings.check.numberFormat),
            }
        };
    }


    function getSelecctedChartCategory(values) {
        return chartCategories.find(chartCategory => chartCategory.id === values.chartCategoryId);
    }

    function getChartCategoryIds() {
        return chartCategories.map(chartCategory => chartCategory.id);
    }

    const getCardContentForm = ({
                                    errors,
                                    handleBlur,
                                    handleChange,
                                    handleSubmit,
                                    isSubmitting,
                                    setFieldValue,
                                    touched,
                                    values
                                }) => {
        return (
            <Grid
                container
                spacing={4}
            >

                {/*<p>{JSON.stringify(values)}</p>*/}
                <Grid
                    item
                    md={12}
                    xs={12}
                >
                    <TextField
                        inputProps={{
                            autocomplete:"new-password"
                        }}
                        fullWidth
                        helperText={touched.name && errors.name}
                        label={localStrings.name}
                        name="name"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        variant="standard"
                        required
                        value={values.name}
                    />
                </Grid>

                <Grid
                    item
                    md={12}
                    xs={12}
                >
                    <TextField
                        inputProps={{
                            autocomplete:"new-password"
                        }}
                        fullWidth
                        helperText={touched.chartMediaUrl && errors.chartMediaUrl}
                        label={localStrings.chartMediaUrl}
                        name="chartMediaUrl"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        variant="standard"
                        value={values.chartMediaUrl}
                    />
                </Grid>

                <Grid
                    item
                    md={12}
                    xs={12}
                >
                    <TextField
                        inputProps={{
                            autocomplete:"new-password"
                        }}
                        fullWidth
                        helperText={touched.title && errors.title}
                        label={localStrings.title}
                        name="title"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        variant="standard"
                        value={values.title}
                    />
                </Grid>

                <Grid
                    item
                    md={12}
                    xs={12}
                >
                    <TextField
                        inputProps={{
                            autocomplete:"new-password"
                        }}
                        fullWidth
                        helperText={touched.height && errors.height}
                        label={localStrings.heightInPixel}
                        name="height"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        variant="standard"
                        value={values.height}
                    />
                </Grid>

                <Grid
                    item
                    md={12}
                    xs={12}
                >
                    {/*<p>{values.chartCategoryId}</p>*/}
                    {/*<p>{JSON.stringify(chartCategories)}</p>*/}
                    {/*<p>{JSON.stringify(chartCategories.find(chartCategory => chartCategory.id === values.chartCategoryId))}</p>*/}
                    <Autocomplete
                        fullWidth
                        disablePortal
                        getOptionLabel={
                            (chartCategoryId) => {
                                return chartCategories.find(chartCategory => chartCategory.id === chartCategoryId)?.name;
                            }
                        }
                        options={getChartCategoryIds()}
                        value={values.chartCategoryId}
                        // value={chartCategories[1]}
                        onChange={
                            async  (event, value) => {
                                setFieldValue('chartCategoryId', value);
                            }}
                        renderInput={(params) => <TextField {...params} label={localStrings.chartCategory} />}
                    />
                </Grid>

                <Grid
                    item
                    md={12}
                    xs={12}
                >
                    <AceCodeEditor
                        code={
                            codeStart}
                        readOnly={true}
                        // setCode={(code) => setFieldValue('base64Code', code)}
                        mode="javascript"
                        style={{height: '20px', marginBottom: '1px'}}
                    />

                    <AceCodeEditor
                        code={values.code}
                        setCode={(code) => setFieldValue('code', code)}
                        mode="javascript"
                        style={{height: '400px', marginBottom: '1px'}}
                    />

                    <AceCodeEditor
                        code={"}"}
                        readOnly={true}
                        // setCode={(code) => setFieldValue('base64Code', code)}
                        mode="javascript"
                        style={{height: '20px', marginBottom: '1px'}}
                    />

                </Grid>

                <Divider/>


                <Grid
                    item
                    md={12}
                    xs={12}
                >

                    <Typography variant="h4" sx={{mb: 2}}>
                        {localStrings.filters}
                    </Typography>

                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={values.allowedCategoryFilter}
                                    onChange={() => setFieldValue('allowedCategoryFilter', !values.allowedCategoryFilter)}
                                />
                            }
                            label={localStrings.allowedCategoryFilter}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={values.allowedProductFilter}
                                    onChange={() => setFieldValue('allowedProductFilter', !values.allowedProductFilter)}
                                />
                            }
                            label={localStrings.allowedProductFilter}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={values.allowedStaffFilter}
                                    onChange={() => setFieldValue('allowedStaffFilter', !values.allowedStaffFilter)}
                                />
                            }
                            label={localStrings.allowedStaffFilter}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={values.allowedLocationFilter}
                                    onChange={() => setFieldValue('allowedLocationFilter', !values.allowedLocationFilter)}
                                />
                            }
                            label={localStrings.allowedLocationFilter}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={values.allowedEstablishmentFilter}
                                    onChange={() => setFieldValue('allowedEstablishmentFilter', !values.allowedEstablishmentFilter)}
                                />
                            }
                            label={localStrings.allowedEstablishmentFilter}
                        />

                    </FormGroup>
                </Grid>

                <Grid
                    item
                    md={12}
                    xs={12}
                >
                    <Typography variant="h4" sx={{mb: 2}}>
                        {localStrings.groups}
                    </Typography>

                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={values.allowedGroupByLocation}
                                    onChange={() => setFieldValue('allowedGroupByLocation', !values.allowedGroupByLocation)}
                                />
                            }
                            label={localStrings.groupByLocation}
                        />

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={values.allowedGroupByStaff}
                                    onChange={() => setFieldValue('allowedGroupByStaff', !values.allowedGroupByStaff)}
                                />
                            }
                            label={localStrings.groupByStaff}
                        />

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={values.allowedGroupByCategory}
                                    onChange={() => setFieldValue('allowedGroupByCategory', !values.allowedGroupByCategory)}
                                />
                            }
                            label={localStrings.groupByCategory}
                        />

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={values.allowedGroupByEstablishment}
                                    onChange={() => setFieldValue('allowedGroupByEstablishment', !values.allowedGroupByEstablishment)}
                                />
                            }
                            label={localStrings.groupByEstablishment}
                        />
                    </FormGroup>

                </Grid>
            </Grid>
        );
    }




    return (

        <>


            {/*<p>{JSON.stringify(getChartImplementation(chartImplementationId, modeEdit, navigate) || [])}</p>*/}
            {currentEstablishment() && currentBrand() && chartCategories &&
                <GeneralEditor getItemFunction={() =>
                    getChartImplementation(chartImplementationId, modeEdit, navigate)}
                               className={className}
                               buildFormValues={buildFormValues}
                               getCardContentForm={getCardContentForm}
                               saveForm={(item, values) => saveForm(item, values, modeEdit, navigate, filter)}
                               applyButton={modeEdit == MODE_CREATE ? localStrings.create : localStrings.update}
                               resetFormProp={modeEdit == MODE_CREATE}
                               messageSuccess={modeEdit == MODE_CREATE ?
                                   localStrings.notif.chartImplementationCreated : localStrings.notif.chartImplementationUpdated}
                               titleForm={modeEdit == MODE_CREATE ? localStrings.createChartImplementation : localStrings.updateChartImplementation}
                               getPathToData={(result) => {
                                   return result.data.getChartImplementation;
                               }}
                />
            }
        </>
    )
};

export default ChartImplementationCreateUpdateForm;
